import React, { useState } from 'react';
// Side-effect import: guarantees the ui-dashboard-bundle entrypoint always
// emits a CSS asset, which layouts reference via stylesheet_pack_tag.
import './UiDashboard.css';
import EasyLlamaWizard from '../../../ui-dashboard/src/components/EasyLlamaWizard';

const UiDashboard = (props) => {

  return (
    <div>
      <EasyLlamaWizard companyId={props.companyId} jwt={props.jwt} trainingId={props.trainingId} learnerId={props.learnerId} originalTemplateId={props.originalTemplateId} />
    </div>
  );
};

export default UiDashboard;
